import { CadNextNotification, CadNextNotificationTypeEnumType } from '@mark43/cad-api';
import { getNotificationWithHigherPriority } from '../../../event-notifications/notification-with-higher-priority';

export function getCounterNotifications(
    notifications: CadNextNotification[]
): CadNextNotification[] {
    return Object.values(
        notifications.reduce((acc, notification) => {
            if (!acc[notification.eventId]) {
                acc[notification.eventId] = {};
            }
            if (!acc[notification.eventId][notification.notificationType]) {
                acc[notification.eventId][notification.notificationType] = notification;
            }
            const existingNotificationForType =
                acc[notification.eventId][notification.notificationType];
            if (existingNotificationForType) {
                const notificationWithHigherPriority = getNotificationWithHigherPriority(
                    existingNotificationForType,
                    notification
                );
                acc[notification.eventId][notification.notificationType] =
                    notificationWithHigherPriority;
            }
            return acc;
        }, {} as Record<number, Partial<Record<CadNextNotificationTypeEnumType, CadNextNotification>>>)
    )
        .map((x) => Object.values(x))
        .flat();
}
